import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AccArrowDown from '../../../../images/contract-admin-icons/AccArrowDown';
import AccArrowUp from '../../../../images/contract-admin-icons/AccArrowUp';
import { HISTORICAL_DATA } from '../../constants';

const historicalDataArray = HISTORICAL_DATA;
const d = new Date();
const year = d.getFullYear();
const AccordionSecondChild = ({
  child,
  findObjectAndUpdate,
  data,
  hidden,
  twoYrBackData,
  contractEnd,
}) => {
  const [active, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!active);
  };
  useEffect(() => {
    if (hidden) {
      setActive(true);
    }
  }, [hidden]);
  return (
    <Fragment>
      {!hidden ? (
        <div className="ent-acc-child">
          <button
            type="button"
            disabled={!child.nodes}
            className={
              child.nodes ? 'ent-acc-toggle' : 'display-hide ent-acc-toggle'
            }
            onClick={handleToggle}
          >
            {active ? <AccArrowUp /> : <AccArrowDown />}
          </button>
          <div className="ent-table-content-old">
            <input
              type="checkbox"
              key={Math.random()}
              value={child.autoRemove}
              disabled={!(child.selected || child.isAnyChildSelected)}
              defaultChecked={child.autoRemove}
              id="autoRemove"
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.checked, data)
              }
            />
          </div>
          <div className="ent-table-content-auto">
            <input
              type="checkbox"
              key={Math.random()}
              disabled={!(child.selected || child.isAnyChildSelected)}
              defaultChecked={child.autoAdd}
              id="autoAdd"
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.checked, data)
              }
            />
          </div>
          <div className="ent-table-content-history">
            <select
              value={child.historicalData}
              key={Math.random()}
              disabled={!(child.selected || child.isAnyChildSelected)}
              id="historicalData"
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.value, data)
              }
            >
              {data.historicalData
                ? historicalDataArray.map((item, i) => {
                    if (data.historicalData && i <= data.historicalData) {
                      return (
                        <option
                          key={item.value}
                          onClick={e =>
                            findObjectAndUpdate(child, e, e.target.value)
                          }
                        >
                          {item.value}
                        </option>
                      );
                    }
                  })
                : historicalDataArray.map(item => (
                    <option key={item.value}>{item.value}</option>
                  ))}
            </select>
          </div>
          <div
            className={
              child.isAnyChildSelected
                ? 'ent-table-second-child-release isAnyItemSelected'
                : 'ent-table-second-child-release'
            }
          >
            <input
              className="ent-table-second-child-release-input"
              key={Math.random()}
              type="checkbox"
              id="selected"
              defaultChecked={child.selected}
              onChange={e =>
                findObjectAndUpdate(child, e, e.target.checked, data)
              }
            />
            <label htmlFor={child.optionName} title={child.optionName}>
              {child.optionName}
            </label>
          </div>
        </div>
      ) : (
        ''
      )}
      {active && child.nodes && (
        <div className="ent-acc-year-data">
          <ul
            className={
              child.nodes.length > 5
                ? 'ent-acc-year-data-list'
                : 'ent-acc-year-data-single-list'
            }
          >
            {active &&
              child.nodes &&
              child.nodes.map(item => {
                return (
                  <li
                    key={item.optionName}
                    className={
                      child.startYear && item.optionName < child.startYear
                        ? 'display-none'
                        : 'ent-acc-last-child'
                    }
                  >
                    <input
                      type="checkbox"
                      key={Math.random()}
                      id="selected"
                      disabled={
                        twoYrBackData && item.optionName > contractEnd - 2
                      }
                      defaultChecked={item.selected}
                      onChange={e =>
                        findObjectAndUpdate(item, e, e.target.checked, child)
                      }
                    />
                    <label htmlFor={item.optionName} title={item.optionName}>
                      {item.optionName}
                    </label>
                    {twoYrBackData &&
                      item.optionName >= year - 1 &&
                      item.optionName < contractEnd - 1 && <span>*</span>}
                  </li>
                );
              })}
          </ul>
        </div>
      )}
    </Fragment>
  );
};
AccordionSecondChild.propTypes = {
  child: PropTypes.shape({}),
  findObjectAndUpdate: PropTypes.func,
  data: PropTypes.shape({}),
  hidden: PropTypes.bool,
  twoYrBackData: PropTypes.bool,
  contractEnd: PropTypes.string,
};
export default React.memo(AccordionSecondChild);
